<template>
  <div class="col-12 p-0">
    <!-- Daily total -->
    <div class="col-12" translate>{{ $t("message.Daily Total:") }}</div>
    <div class="col-12" style="padding-left: 0px">
      <div class="row" style="font-size: x-small">
        <div class="col-2">
          <div
            class="col-md-12"
            translate
            style="font-size: x-small; display: flex"
          >
            {{ $t("message.Energy") }}
          </div>
          <div class="col-12" style="display: grid">
            {{ getNutritionValueForDay("energy") }}
            <span style="font-size: 0.8em">{{
              $t("message.Kcal")
            }}</span>
          </div>
        </div>
        <div class="col-2">
          <div
            class="col-md-12"
            translate
            style="font-size: x-small; display: flex"
          >
            {{ $t("message.Fat") }}
          </div>
          <div class="col-12" style="display: grid">
            {{ getNutritionValueForDay("fat") }}
            <span style="font-size: 0.8em">{{
              $t("message.g")
            }}</span>
          </div>
        </div>
        <div class="col-2">
          <div
            class="col-md-12"
            translate
            style="font-size: x-small; display: flex"
          >
            {{ $t("message.Carbs") }}
          </div>
          <div class="col-12" style="display: grid">
            {{ getNutritionValueForDay("carbohydrates") }}
            <span style="font-size: 0.8em">{{
              $t("message.g")
            }}</span>
          </div>
        </div>
        <div class="col-2">
          <div
            class="col-md-12"
            translate
            style="font-size: x-small; display: flex"
          >
            {{ $t("message.Protein") }}
          </div>
          <div class="col-12" style="display: grid">
            {{ getNutritionValueForDay("protein") }}
            <span style="font-size: 0.8em">{{
              $t("message.g")
            }}</span>
          </div>
        </div>
        <div class="col-2">
          <div
            class="col-12"
            translate
            style="font-size: x-small; display: flex"
          >
            {{ $t("message.Fibre") }}
          </div>
          <div class="col-12" style="display: grid">
            {{ getNutritionValueForDay("fibre") }}
            <span style="font-size: 0.8em">{{
              $t("message.g")
            }}</span>
          </div>
        </div>
        <div class="col-2">
          <div
            class="col-md-12"
            translate
            style="font-size: x-small; display: flex"
          >
            {{ $t("message.Water") }}
          </div>
          <div class="col-12" style="display: grid">
            {{ getNutritionValueForDay("water") }}
            <span style="font-size: 0.8em">{{
              $t("message.g")
            }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Plan -->
    <div
      class="card-wrap"
      v-for="(plan, time) in dailyPlan"
      :key="time"
      style="width: 100%; font-size: x-small; margin-top: 13px"
    >
      <div class="row" v-if="time != 'dailyTotal'">
        <div class="col-12">
          <div class="card card-blue">
            <div class="card-main">
              <div class="card-inner" style="padding: 16px">
                <div id="daily-diet-plan">
                  <div class="row">
                    <span class="col-4" style="padding-bottom: 5px">{{
                      time | capitalCase
                    }}</span>

                    <!-- Time -->
                    <div class="col-8 pull-right">
                      <div class="row" v-if="plan.time">
                        <!-- Absolute Time -->
                        <div class="col-12" v-if="!plan.time.isRelative">
                          <div class="row">
                            <div class="col-3 p-0">
                              {{ plan.time.absolute.startTime }}
                            </div>
                            <div class="col-1 p-0">--</div>
                            <div class="col-4 p-0">
                              {{ plan.time.absolute.endTime }}
                            </div>
                          </div>
                        </div>

                        <!-- Relative Time -->
                        <div class="col-12" v-if="plan.time.isRelative">
                          {{ plan.time.relative.time }}
                          {{ plan.time.relative.unit }}
                          {{ plan.time.relative.when }}
                          {{ plan.time.relative.event }}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-12">
                      <div class="tile-wrap">
                        <div
                          class="card"
                          v-for="foodOption in plan.foodOptions"
                        >
                          <div>
                            <div
                              class="card-body"
                              style="
                                font-weight: 400;
                                font-size: small;
                                padding-top: 7px;
                                padding-bottom: 7px;
                              "
                            >
                              <div class="row">
                                <div
                                  class="col-12"
                                  v-for="foodItem in foodOption"
                                >
                                  <div class="col-12" style="padding: 0px">
                                    <div
                                      class="col-12"
                                      style="
                                        padding-top: 5px;
                                        padding-bottom: 5px;
                                      "
                                    >
                                      <div
                                        class="row"
                                        style="
                                          border: 1px solid #d4d0d0;
                                          border-radius: 4px;
                                        "
                                      >
                                        <div
                                          class="col-10"
                                          style="padding-right: 0px"
                                        >
                                          <span
                                            class="text-overflow"
                                            style="
                                              text-align: center;
                                              font-size: x-small;
                                            "
                                            >{{
                                              foodItem.portion.value +
                                              " " +
                                              foodItem.portion.unit +
                                              " of " +
                                              foodItem.name +
                                              "(Total: " +
                                              foodItem.quantity.value +
                                              foodItem.quantity.unit +
                                              ")"
                                            }}</span
                                          >
                                        </div>
                                      </div>
                                    </div>
                                    <div
                                      class="col-1 text-center offset-5"
                                      style="
                                        padding: 0px;
                                        background-color: #f5f5f5;
                                        border: 1px solid #e3e3e3;
                                        border-radius: 4px;
                                        box-shadow: inset 0 1px 1px
                                          rgba(0, 0, 0, 0.05);
                                      "
                                      v-if="
                                        foodOption.indexOf(foodItem) !=
                                        foodOption.length - 1
                                      "
                                    >
                                      or
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      class="col-md-12 text-center text-primary"
                      v-if="plan.foodOptions && plan.foodOptions.length < 1"
                      translate
                    >
                      {{ $t("message.No Plan") }}
                    </div>
                  </div>

                  <div
                    class="row"
                    style="margin-top: 1em; font-size: 0.9em"
                    v-if="plan.foodOptions && plan.foodOptions.length > 0"
                  >
                    <div class="col-2 text-center p-0">
                      <div class="col-12 p-0">
                        {{ $t("message.Energy") }}
                      </div>
                      <div class="col-md-12 p-0">
                        {{ getNutritionValue("energy", time) }}
                        <span style="font-size: 0.8em">{{
                          $t("message.Kcal")
                        }}</span>
                      </div>
                    </div>
                    <div class="col-2 text-center p-0">
                      <div class="col-12 p-0">
                        {{ $t("message.Fat") }}
                      </div>
                      <div class="col-12 p-0">
                        {{ getNutritionValue("fat", time) }}
                        <span style="font-size: 0.8em">{{
                          $t("message.g")
                        }}</span>
                      </div>
                    </div>
                    <div class="col-2 text-center p-0">
                      <div class="col-12 p-0">
                        {{ $t("message.Carbs") }}
                      </div>
                      <div class="col-md-12">
                        {{ getNutritionValue("carbohydrates", time) }}
                        <span style="font-size: 0.8em">{{
                          $t("message.g")
                        }}</span>
                      </div>
                    </div>
                    <div class="col-2 text-center p-0">
                      <div class="col-md-12 p-0">
                        {{ $t("message.Protein") }}
                      </div>
                      <div class="col-md-12">
                        {{ getNutritionValue("protein", time) }}
                        <span style="font-size: 0.8em">{{
                          $t("message.g")
                        }}</span>
                      </div>
                    </div>
                    <div class="col-2 text-center p-0">
                      <div class="col-md-12 p-0">
                        {{ $t("message.Fibre") }}
                      </div>
                      <div class="col-md-12">
                        {{ getNutritionValue("fibre", time) }}
                        <span style="font-size: 0.8em">{{
                          $t("message.g")
                        }}</span>
                      </div>
                    </div>
                    <div class="col-2 text-center p-0">
                      <div class="col-md-12 p-0">
                        {{ $t("message.Water") }}
                      </div>
                      <div class="col-md-12">
                        {{ getNutritionValue("water", time) }}
                        <span style="font-size: 0.8em">{{
                          $t("message.g")
                        }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "daily-diet-plan",

  props: ["dailyPlan"],

  methods: {
    getNutritionValueForDay(type) {
      var totalValue = 0;
      for (var timeOfTheDay in this.dailyPlan) {
        totalValue =
          totalValue + parseFloat(this.getNutritionValue(type, timeOfTheDay));
      }
      if (!this.dailyPlan.dailyTotal) {
        this.dailyPlan.dailyTotal = {};
      }
      this.dailyPlan.dailyTotal[type] = {
        value: totalValue.toFixed(2),
      };

      return totalValue.toFixed(2);
    },
    getNutritionValue(type, timeOfTheDay) {
      var totalValue = 0;
      if (this.dailyPlan[timeOfTheDay].foodOptions) {
        this.dailyPlan[timeOfTheDay].foodOptions.forEach(function (option) {
          //Get highest kcal value from the alternative food items
          var highestKiloCalorie = Math.max.apply(
            Math,
            option.map(function (food) {
              if (food[type] && food[type].value) {
                return food[type].value;
              } else {
                return 0;
              }
            })
          );

          totalValue = highestKiloCalorie + totalValue;
        });
      }

      return totalValue.toFixed(2);
    },
  },

  filters: {
    capitalCase: (value) => {
      if (value) {
        return value.toUpperCase();
      }
    },
  },
};
</script>

<style scoped>
.card .card-body {
  padding: 15px 15px 10px 15px !important;
}
</style>
